//components
import React from "react";

//styling
import "./SendInvite.scss";
import "../../../Resources/Styles/fonts.scss";

//resources
import { Strings } from "../../../Resources/Strings/i18n";
import Button from "@material-ui/core/Button";

class SendInvite extends React.Component {
  render() {
    return (
      <div className="SendInvite">
        <div className="SendInvite_textInfo">
          <div className="SendInvite_heading">{Strings("Manage_Access")}</div>
          <div className="SendInvite_text">
            {Strings("Manage_AccessInfo")}
          </div>
        </div>
       
          <div className="SendInvite_AddContacts">
            <div className="turnOnButton GiveAccess">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={this.props.showSendInvitationModal}
                >
                {Strings("GiveAccess")}
              </Button>
            </div>
            <div className="turnOnButton">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={this.props.showSendInvitationModal}
                >
                {Strings("CaregiverBtnText")}
              </Button>
            </div>
          </div>
        
      </div>
    );
  }
}

export default SendInvite;
